import { render } from "./QrPaymentDialog.vue?vue&type=template&id=140e635d"
import script from "./QrPaymentDialog.vue?vue&type=script&lang=js"
export * from "./QrPaymentDialog.vue?vue&type=script&lang=js"

import "./QrPaymentDialog.vue?vue&type=style&index=0&id=140e635d&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__